export default class FindALocationFieldValidator {
	constructor(dom) {
		this.dom = dom;

		this.MSG_ZIPCODECOUNTY = window.config.locationFilters.messages.zipcodecounty;
		this.MSG_ZIPCODE = window.config.locationFilters.messages.zipcode;
		this.MSG_COUNTY = window.config.locationFilters.messages.county;
		this.MSG_GENERIC = window.config.locationFilters.messages.generic;
		this.MSG_MARKET = window.config.locationFilters.messages.market;
	}

	validateMarketDropdown(dropdown) {
		if (!dropdown.exists()) {
			return true;
		}

		if (dropdown.isDefaultValue()) {
			this.setValidation(dropdown.domElement(), this.MSG_MARKET);
			return false;
		}

		return true;
	}

	validateMarketsAgainstZipStateAndCounty(stateDropdown, countyDropdown) {
		if (!stateDropdown.exists() || !countyDropdown.exists()) {
			return true;
		}

		if (this.zipIsEmpty() && stateDropdown.isDefaultValue() && countyDropdown.isDefaultValue()) {
			this.setValidation(this.dom.getZipInput(), this.MSG_ZIPCODECOUNTY);
			this.setValidation(stateDropdown.domElement(), this.MSG_ZIPCODECOUNTY);
			return false;
		}

		return true;
	}

	validateCountyAgainstZipAndState(stateDropdown, countyDropdown) {
		if (!stateDropdown.exists() || !countyDropdown.exists()) {
			return true;
		}

		if (this.zipIsEmpty() && stateDropdown.isNotDefaultValue() && countyDropdown.isDefaultValue()) {
			this.setValidation(countyDropdown.domElement(), this.MSG_COUNTY);

			return false;
		}

		return true;
	}

	validateZipAgainstZipAndState(stateDropdown) {
		if (!stateDropdown.exists()) {
			return true;
		}

		if (this.zipIsEmpty() && stateDropdown.isHidden()) {
			this.setValidation(this.dom.getZipInput(), this.MSG_ZIPCODE);

			return false;
		}

		return true;
	}

	validateQueryField() {
		if (this.dom.getQueryField().value === "") {
			this.setValidation(this.dom.getQueryField(), this.MSG_GENERIC);
			return false;
		}

		return true;
	}

	zipIsEmpty() {
		return this.dom.getZipInput().value === "";
	}

	setValidation($control, message) {
		$control.classList.add("error");

		this.dom.showError(message);
	}
}
